exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "checkbox-list-item{display:block}checkbox-list-item>div label{margin:0}checkbox-list-item>div>.item-sublist>div{padding-left:40px}checkbox-list-item>div>.item-wrapper{padding:10px 0;display:flex;align-items:center}checkbox-list-item>div>.item-wrapper>input-checkbox{margin-right:10px}", ""]);

